import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import Logo from "./Logo";

export default function Footer({ onManageCookies }) {
  const { lang, t } = useI18n();
  const base = `/${lang}`;

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="zx-footer" id="footer">
      <div className="zx-footer__grid">
        <div className="zx-footer__col zx-footer__col--brand">
          <Logo />
          <p className="zx-footer__tag">{t("footer.tagline")}</p>
          <p className="zx-footer__risk">{t("footer.riskWarning")}</p>
        </div>

        <div className="zx-footer__col">
          <h4 className="zx-footer__title">{t("footer.exploreTitle")}</h4>
          <ul className="zx-footer__list">
            <li><Link to={base}>{t("nav.home")}</Link></li>
            <li><a href={`${base}#how`}>{t("nav.how")}</a></li>
            <li><a href={`${base}#projects`}>{t("nav.projects")}</a></li>
            <li><a href={`${base}#about`}>{t("nav.about")}</a></li>
            <li><a href={`${base}#contact`}>{t("nav.contact")}</a></li>
          </ul>
        </div>

        <div className="zx-footer__col">
          <h4 className="zx-footer__title">{t("footer.legalTitle")}</h4>
          <ul className="zx-footer__list">
            <li><Link to={`${base}/privacy`}>{t("privacy.title")}</Link></li>
            <li><Link to={`${base}/cookies`}>{t("cookiePolicy.title")}</Link></li>
            <li><Link to={`${base}/terms`}>{t("terms.title")}</Link></li>
            <li>
              <button type="button" className="zx-linklike" onClick={onManageCookies}>
                {t("footer.manageCookies")}
              </button>
            </li>
          </ul>
        </div>

        <div className="zx-footer__col">
          <h4 className="zx-footer__title">{t("footer.contactTitle")}</h4>
          <ul className="zx-footer__list">
            <li><a href={`mailto:${t("contact.emailAddress")}`}>{t("contact.emailAddress")}</a></li>
            <li><a href={`tel:${t("contact.phone").replace(/\s/g, "")}`}>{t("contact.phone")}</a></li>
            <li className="zx-footer__addr">{t("contact.address")}</li>
          </ul>
        </div>

        <div className="zx-footer__col zx-footer__col--wide">
          <h4 className="zx-footer__title">{t("footer.companyTitle")}</h4>
          <ul className="zx-footer__list zx-footer__list--legal">
            <li>{t("footer.companyLegalName")}</li>
            <li>{t("footer.companyAddress")}</li>
            <li>{t("footer.registration")}</li>
            <li>{t("footer.oib")}</li>
            <li>{t("footer.vat")}</li>
            <li>{t("footer.license")}</li>
            <li>{t("footer.licenseAuthority")}</li>
            <li>{t("footer.jurisdiction")}</li>
            <li>{t("footer.founded")}</li>
          </ul>
        </div>
      </div>

      <div className="zx-footer__bar">
        <span>{t("footer.copyright")}</span>
        <button type="button" className="zx-linklike" onClick={scrollToTop}>
          {t("footer.backToTop")} ↑
        </button>
      </div>
    </footer>
  );
}
